'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HOLDS_ACTION_RESUME = exports.HOLDS_ACTION_PAUSE = exports.HOLDS_ACTION_CANCEL = exports.HOLDS_ACTION_PLACE = exports.RESUME_HOLD_EVENT = exports.PAUSE_HOLD_EVENT = exports.CANCEL_HOLD_EVENT = exports.PLACE_HOLD_EVENT = exports.HOLDS_GTM_CATEGORY = undefined;
exports.composeCancelHoldEvent = composeCancelHoldEvent;
exports.composePlaceHoldEvent = composePlaceHoldEvent;
exports.composePauseHoldEvent = composePauseHoldEvent;
exports.composeResumeHoldEvent = composeResumeHoldEvent;

var _compose = require('./compose');

var _shelvesEventComposer = require('./shelvesEventComposer');

var HOLDS_GTM_CATEGORY = exports.HOLDS_GTM_CATEGORY = 'v2-holds';

var PLACE_HOLD_EVENT = exports.PLACE_HOLD_EVENT = 'bc.placeHold';
var CANCEL_HOLD_EVENT = exports.CANCEL_HOLD_EVENT = 'bc.cancelHold';
var PAUSE_HOLD_EVENT = exports.PAUSE_HOLD_EVENT = 'bc.pauseHold';
var RESUME_HOLD_EVENT = exports.RESUME_HOLD_EVENT = 'bc.resumeHold';

var HOLDS_ACTION_PLACE = exports.HOLDS_ACTION_PLACE = 'v2-place';
var HOLDS_ACTION_CANCEL = exports.HOLDS_ACTION_CANCEL = 'v2-cancel';
var HOLDS_ACTION_PAUSE = exports.HOLDS_ACTION_PAUSE = 'v2-pause';
var HOLDS_ACTION_RESUME = exports.HOLDS_ACTION_RESUME = 'v2-resume';

function composeHoldEvent(eventName, eventValue, metadataIds, eventAction) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: eventValue,
    gtmAction: eventAction,
    gtmCategory: HOLDS_GTM_CATEGORY,
    metadataIds: metadataIds
  });
}

function composeCancelHoldEvent(holdCount, metadataIds, shelfState) {
  var events = [];
  if (shelfState && shelfState.toAdd) {
    events.push((0, _shelvesEventComposer.composeShelfEvent)(_shelvesEventComposer.ADD_TO_SHELF_EVENT, metadataIds, shelfState.name, _shelvesEventComposer.SHELF_ACTION_ADD));
  }
  events.push(composeHoldEvent(CANCEL_HOLD_EVENT, holdCount, metadataIds, HOLDS_ACTION_CANCEL));
  return (0, _compose.composeAnalytics)(events);
}

function composePlaceHoldEvent(metadataIds) {
  return (0, _compose.composeAnalytics)([composeHoldEvent(PLACE_HOLD_EVENT, 1, metadataIds, HOLDS_ACTION_PLACE)]);
}

function composePauseHoldEvent(holdCount, metadataIds) {
  return (0, _compose.composeAnalytics)([composeHoldEvent(PAUSE_HOLD_EVENT, holdCount, metadataIds, HOLDS_ACTION_PAUSE)]);
}

function composeResumeHoldEvent(holdCount, metadataIds) {
  return (0, _compose.composeAnalytics)([composeHoldEvent(RESUME_HOLD_EVENT, holdCount, metadataIds, HOLDS_ACTION_RESUME)]);
}

exports.default = {
  HOLDS_GTM_CATEGORY: HOLDS_GTM_CATEGORY,
  PLACE_HOLD_EVENT: PLACE_HOLD_EVENT,
  CANCEL_HOLD_EVENT: CANCEL_HOLD_EVENT,
  PAUSE_HOLD_EVENT: PAUSE_HOLD_EVENT,
  RESUME_HOLD_EVENT: RESUME_HOLD_EVENT,
  HOLDS_ACTION_PLACE: HOLDS_ACTION_PLACE,
  HOLDS_ACTION_CANCEL: HOLDS_ACTION_CANCEL,
  HOLDS_ACTION_PAUSE: HOLDS_ACTION_PAUSE,
  HOLDS_ACTION_RESUME: HOLDS_ACTION_RESUME,
  composePlaceHoldEvent: composePlaceHoldEvent,
  composeCancelHoldEvent: composeCancelHoldEvent,
  composePauseHoldEvent: composePauseHoldEvent,
  composeResumeHoldEvent: composeResumeHoldEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/holdsEventComposer.js
// module id = 553
// module chunks = 0 2 4 6 7 8 9 10